import { createEffect, createEvent, sample } from 'effector';
import { debounce } from 'patronum';
import { parse } from 'date-fns';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import { formatPhone } from '@tools/formatPhone';
import * as api from './api';
import type {
  SearchResidentsPayload,
  SearchResidentsResponse,
  SearchResident,
} from './types';

export const searchResidents = createEvent<SearchResident>();
export const resetData = createEvent<void>();

const fxSearchResidents = createEffect<
  SearchResidentsPayload,
  SearchResidentsResponse,
  Error
>().use(api.searchResidents);

export const searchResidentsQuery = createQuery({
  effect: fxSearchResidents,
  mapData: ({ result }) =>
    Array.isArray(result?.residents)
      ? result.residents.map((item) => ({
          id: item?.resident_guid,
          residentId: item?.resident_id,
          label: item?.title ?? item?.fio ?? '',
          phone: item?.phone ? formatPhone(item.phone) : '',
          email: item?.email ?? '',
          birthday: item?.birthday
            ? parse(item.birthday, 'dd.MM.yyyy', new Date())
            : null,
        }))
      : [],
});

searchResidentsQuery.$data.reset([signout, resetData]);

cache(searchResidentsQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

/** Запрос данных */
sample({
  clock: debounce({
    source: searchResidents,
    timeout: 1000,
  }),
  fn: ({ value, residentType }) => ({
    search: value,
    resident_type: residentType,
  }),
  target: searchResidentsQuery.start,
});
